export default "__VITE_ASSET__Bm36LwKb__"